
import React from 'react';
import type { FeatureCollection } from 'geojson';
import { CircleLayer, Layer, Source } from 'react-map-gl';
import { IExploreVenue } from '../../../types';

interface IProps {
  venues: IExploreVenue[];
}

const layerStyle: CircleLayer = {
  id: 'point',
  type: 'circle',
  paint: {
    'circle-radius': ['case', ['==', ['get', 'isOutsideDateRange'], true], 12, 30],
    'circle-color': '#ffdd00',
    'circle-opacity': {
      property: 'memoriesCount',
      stops: [
        [1, 0.1],
        [2, 0.15],
        [3, 0.2],
        [4, 0.25],
      ]
    }
  }
};

function MemoriesGlowLayer({ venues }: IProps): React.ReactElement {

  const geojson: FeatureCollection = React.useMemo(()=> ({
    type: 'FeatureCollection',
    features: venues
      .filter((venue) => venue.memories?.length)
      .map((venue) => ({
        type: 'Feature',
        geometry: { type: 'Point', coordinates: [venue.coordinates[1], venue.coordinates[0]] },
        properties: { memoriesCount: venue.memories?.length || 0, isOutsideDateRange: venue.isOutsideDateRange ?? false },
      })),
  }), [venues]);

  return (
    <Source id="my-data" type="geojson" data={geojson}>
      <Layer {...layerStyle} />
    </Source>
  );
}

export default MemoriesGlowLayer;
